export const PILOT_DATA_FRAMES_TABLE_ENGLISH_LOCALE = {
  globalSearchPlaceholder: "Search a value...",
  empty: "No logs found...",
  headers: {
    id: "Log Id",
    arrivalDate: "Arrival date",
    pilotSentDate: "Sent date",
    frame: "Frame",
    pilotHwId: "Pilot Hw Id",
    pilotIp: "Pilot IP",
    typeDescription: "Type",
    typeClassDescription: "Class",
  },
  filters: {
    placeholders: {
      id: "Search by log id...",
      arrivalDate: "Search by arrival date...",
      pilotSentDate: "Search by sent date...",
      frame: "Search by frame...",
      pilotHwId: "Search by pilot iw id...",
      pilotIp: "Search by pilot ip...",
      typeDescription: "Search by type...",
      typeClassDescription: "Search by class...",
    },
  },
};
